// Port of api/fuel/app/classes/filter/search/games/filters/query/game/rank.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'game.rank',
	priority: 35,
	require: function(config, filter) {
		return rangeActive(filter.rank, 0, 1000)
	},
	run: function(config, filter, data, query) {
		var from = filter.rank.from || 1
		if (from > 0) query.where('g.game_rank', '>=', from)
		if (filter.rank.to < 1000) query.where('g.game_rank', '<=', filter.rank.to)
		query.where('g.game_rank', '>', 0)
	}
}
